import React from 'react';
import BaseComponent from '../../baseClasses/BaseComponent'; 
import './RelativePopout.scss';

export default class RelativePopout extends BaseComponent {

  render() {
    const { top, left, right, verticalOffset } = this.props;
    let { arrowLocation } = this.props;
    if (!arrowLocation) {
      arrowLocation = 'left';
    }

    let style = { top: top, left: left };
    if (right >= 0) {
      style = { top: top, right: right, position: 'absolute', width: '100%' };
    }
      
    // TODO: revisit below (to support vertical/horizontal offset)
    let arrowStyle = arrowLocation == 'left'
      ? { top: 10 + verticalOffset }
      : { };
    return (
      <div id="relative-outer-popout-container"  className="relative-outer-popout-container" style={style}>
      <div className={'popout-container' + (right >= 0 ? ' right' : '')}>
        <div className={'arrow-' + arrowLocation} style={arrowStyle}/> 
        <div className="user-content">
          {this.props.children}
        </div>
      </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RelativePopout/index.js